var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "purchase_part my-2" },
    [
      _c("cabinet-fl44-card-header", { attrs: { purchase: _vm.contract } }),
      _c("cabinet-fl44-card-body", {
        scopedSlots: _vm._u([
          {
            key: "col1",
            fn: function () {
              return [
                _vm.isContractConcluded
                  ? _c(
                      "cabinet-notice-card-row-single",
                      { attrs: { label: "Контракт заключен" } },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.getDateFormat(
                                _vm.contract.purchase_info
                                  .contract_conclusion_date
                              )
                            ) +
                            " "
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm.contract.purchase_info.contract_execution_date
                  ? _c(
                      "cabinet-notice-card-row-single",
                      { attrs: { label: "Контракт исполнен:" } },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.getDateFormat(
                                _vm.contract.purchase_info
                                  .contract_execution_date
                              )
                            ) +
                            " "
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm.contract.purchase_info.contract_price
                  ? _c(
                      "cabinet-notice-card-row-single",
                      { attrs: { label: "Цена контракта" } },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$formatPrice(
                                _vm.contract.purchase_info.contract_price
                              )
                            ) +
                            " руб. "
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm.contract.purchase_info
                  .contract_price_with_supplementary_agreement
                  ? _c(
                      "cabinet-notice-card-row-single",
                      { attrs: { label: "Цена контракта с учётом ДС" } },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$formatPrice(
                                _vm.contract.purchase_info
                                  .contract_price_with_supplementary_agreement
                              )
                            ) +
                            " руб. "
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm.contract.flags.is_customer
                  ? _c("purchase-comment-edit-block", {
                      attrs: { purchase: _vm.contract },
                      on: { refresh: _vm.refresh },
                    })
                  : _vm._e(),
              ]
            },
            proxy: true,
          },
          {
            key: "col2",
            fn: function () {
              return [
                _vm.contract.purchase_info.purchase_name
                  ? _c(
                      "cabinet-notice-card-row-dual",
                      { attrs: { label: "Предмет закупки" } },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.contract.purchase_info.purchase_name) +
                            " "
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm.contract.flags.is_supplier
                  ? _c(
                      "cabinet-notice-card-row-dual",
                      { attrs: { label: "Заказчик" } },
                      [
                        _c(
                          "router-link",
                          {
                            staticClass: "system_link-style",
                            attrs: {
                              to: {
                                name: "OrganizationShow",
                                params: { id: _vm.contract.customer.id },
                              },
                              target: "_blank",
                            },
                          },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.contract.customer.name) + " "
                            ),
                          ]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.contract.flags.is_customer
                  ? _c(
                      "cabinet-notice-card-row-dual",
                      { attrs: { label: "Поставщик" } },
                      [
                        !_vm.contract.supplier.id
                          ? [_vm._v(" — ")]
                          : [
                              _vm.contract.supplier.type === "private"
                                ? [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.contract.supplier.name) +
                                        " "
                                    ),
                                  ]
                                : _c(
                                    "router-link",
                                    {
                                      staticClass: "system_link-style",
                                      attrs: {
                                        to: {
                                          name: "OrganizationShow",
                                          params: {
                                            id: _vm.contract.supplier.id,
                                          },
                                        },
                                        target: "_blank",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.contract.supplier.name) +
                                          " "
                                      ),
                                    ]
                                  ),
                            ],
                      ],
                      2
                    )
                  : _vm._e(),
                _c(
                  "cabinet-notice-card-row-single",
                  { attrs: { label: "Количество позиций" } },
                  [
                    _vm._v(
                      _vm._s(_vm.contract.purchase_info.deliverables_count) +
                        " "
                    ),
                  ]
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "col3",
            fn: function () {
              return [
                _c(
                  "cabinet-fl44-card-info-link",
                  {
                    attrs: {
                      to: {
                        name: "ExternalPurchaseShow",
                        params: { id: _vm.contract.id },
                      },
                      icon: "search",
                    },
                  },
                  [_vm._v("Информация о закупке")]
                ),
                _c(
                  "cabinet-fl44-card-info-link",
                  {
                    attrs: {
                      to: {
                        name: "ExternalPurchaseShow",
                        params: { id: _vm.contract.id },
                        hash: "#contract",
                      },
                      icon: "contract",
                    },
                  },
                  [_vm._v("Контракт")]
                ),
                _vm.contract.flags.has_supplementary_agreements
                  ? _c(
                      "cabinet-fl44-card-info-link",
                      {
                        attrs: {
                          to: {
                            name: "ExternalPurchaseShow",
                            params: { id: _vm.contract.id },
                            hash: "#supplementary-agreements",
                          },
                          icon: "contract",
                        },
                      },
                      [_vm._v("Дополнительные соглашения")]
                    )
                  : _vm._e(),
                _vm.contract.actions.edit_draft
                  ? _c(
                      "b-btn",
                      {
                        staticClass:
                          "btn btn-card-action btn-card-action-green my-1",
                        attrs: {
                          to: {
                            name: "ExternalPurchaseCreate",
                            params: { mode: "edit_draft", id: _vm.contract.id },
                          },
                        },
                      },
                      [_vm._v("Редактировать")]
                    )
                  : _vm._e(),
                _vm.contract.actions.delete
                  ? _c("cabinet-fl44-external-purchase-delete-button", {
                      attrs: { contract: _vm.contract },
                      on: { refresh: _vm.refresh },
                    })
                  : _vm._e(),
                _vm.contract.actions.edit
                  ? _c(
                      "b-btn",
                      {
                        staticClass: "btn btn-card-action my-1",
                        attrs: {
                          to: {
                            name: "ExternalPurchaseEdit",
                            params: { id: _vm.contract.id },
                          },
                        },
                      },
                      [_vm._v("Редактировать")]
                    )
                  : _vm._e(),
                _c("cabinet-fl44-external-purchase-card-copy-button", {
                  attrs: { contract: _vm.contract },
                }),
                _vm.contract.flags.is_customer
                  ? _c("cabinet-fl44-external-purchase-block-request-button", {
                      attrs: { contract: _vm.contract },
                      on: { refresh: _vm.refresh },
                    })
                  : _vm._e(),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }